import { plainToClass } from 'class-transformer'
import http from '../http';
import { Specializzazione } from '@/models/specializzazione.model';

export class SpecializzazioneService {

  constructor() {}
  
  getAll(): Promise<Specializzazione[]> {
    return new Promise((resolve, reject) => {
      http.get(`specializzazioni`).then((response: any) =>
        resolve(plainToClass(Specializzazione, response.data as any[]))).catch((error: any) => reject(error))
    })
  }

}
